"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _Menu = require("./Menu");
var _DateRange = _interopRequireDefault(require("@material-ui/icons/DateRange"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _styles = require("@material-ui/styles");
var _styles2 = require("@material-ui/core/styles");
var _moment = _interopRequireDefault(require("moment"));
var _Modal = require("./Modal");
var _Button = require("./Button");
var _DateSinglePicker = require("./DateSinglePicker");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _clsx7 = _interopRequireDefault(require("clsx"));
var _IconButton = require("./IconButton");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    btnDiv: {
      padding: theme.spacing(3, 2, 2),
      display: "flex",
      justifyContent: "flex-end"
    },
    btn: {
      margin: theme.spacing(0, 1)
    },
    modalNoPadding: {
      padding: 0
    },
    tabsDiv: {
      position: "relative",
      display: "flex",
      height: 48,
      width: 284,
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["5"])
    },
    tabDiv: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      "&:hover": {
        color: _pittaModules.LightColors.primary["7"]
      }
    },
    tabActive: {
      color: _pittaModules.LightColors.primary["7"]
    },
    activeDiv: {
      position: "absolute",
      left: 0,
      bottom: 0,
      height: 3,
      width: "50%",
      backgroundColor: _pittaModules.LightColors.primary["7"],
      transition: theme.transitions.create("left")
    },
    yearSelector: {
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(2)
    },
    monthDiv: {
      display: "flex",
      flexWrap: "wrap",
      width: 284,
      // padding: theme.spacing(0, 2),
      justifyContent: "center"
    },
    monthSelectorDiv: {
      width: 84,
      height: 50.25,
      padding: "6.75px 0 7.5px 0"
    },
    monthSelector: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      borderRadius: theme.spacing(0.5),
      cursor: "pointer"
    },
    monthSelectorActive: {
      backgroundColor: _pittaModules.LightColors.primary["7"],
      color: _pittaModules.LightColors.primary["0"]
    },
    monthSelectorDisabled: {
      opacity: 0.35,
      cursor: "auto"
    },
    modalDiv: {
      width: 284
    },
    hide: {
      display: "none"
    },
    adminInputBackStyle: {
      minWidth: 284,
      backgroundColor: _pittaModules.LightColors.primary["0"]
    }
  };
});
var MONTH_ABBR = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec"
};
var DateSelector = function DateSelector(props) {
  var mobile = props.mobile,
    mode = props.mode,
    disabled = props.disabled,
    enabledDays = props.enabledDays,
    dense = props.dense,
    day = props.day,
    clearDay = props.clearDay,
    placement = props.placement,
    disableAfterToday = props.disableAfterToday,
    disableDayBefore = props.disableDayBefore,
    _onClick = props.onClick,
    onChangeMode = props.onChangeMode,
    t = props.t,
    simAdmin = props.simAdmin;
  var theme = (0, _styles2.useTheme)();
  var now = (0, _react.useMemo)(function () {
    return (0, _moment.default)();
  }, []);
  var classes = useStyles();
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMenu = _useState2[0],
    setOpenMenu = _useState2[1];
  var _useState3 = (0, _react.useState)(day !== null && day !== void 0 ? day : now),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedDay = _useState4[0],
    setSelectedDay = _useState4[1];
  var _useState5 = (0, _react.useState)(day !== null && day !== void 0 ? day : now),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedMonth = _useState6[0],
    setSelectedMonth = _useState6[1];
  var _useState7 = (0, _react.useState)(mode || "day"),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedMode = _useState8[0],
    setSelectedMode = _useState8[1];
  (0, _react.useEffect)(function () {
    var orientationHandler = function orientationHandler(e) {
      setOpenMenu(false);
      console.log("orientationHandler");
    };
    if ("onorientationchange" in window) {
      window.addEventListener("orientationchange", orientationHandler, false);
    }
    window.addEventListener("resize", orientationHandler, false);
    return function () {
      if ("onorientationchange" in window) {
        window.removeEventListener("orientationchange", orientationHandler);
      }
      window.removeEventListener("resize", orientationHandler);
    };
  }, []);

  // mantis - 8604,  <DateSinglePicker>에 day={selectedDay} props를 위하여 받아온 day값 setSelectedDay.
  (0, _react.useEffect)(function () {
    setSelectedDay(day);
  }, [day]);
  (0, _react.useEffect)(function () {
    setSelectedMode(mode || "day");
  }, [mode]);
  var disableClear = (0, _react.useMemo)(function () {
    var now = (0, _moment.default)();
    if (selectedMode === "month") {
      return now.isSame(selectedMonth, selectedMode);
    } else {
      return now.isSame(selectedDay, selectedMode);
    }
  }, [selectedDay, selectedMode, selectedMonth]);
  var getValue = (0, _react.useMemo)(function () {
    if (simAdmin && mode === "month") {
      var _day$endOf;
      return (_day$endOf = day.endOf("month")) === null || _day$endOf === void 0 ? void 0 : _day$endOf.format("YYYY-MM");
    } else if (simAdmin && mode === "day") {
      return day === null || day === void 0 ? void 0 : day.format("YYYY-MM-DD");
    } else if (mode === "month") {
      return day === null || day === void 0 ? void 0 : day.format("MMM, YYYY");
    } else {
      return day === null || day === void 0 ? void 0 : day.format("MMM D, YYYY");
    }
  }, [day, mode, simAdmin]);
  var calendarMarkup = (0, _react.useMemo)(function () {
    var _t, _t2, _t4, _t5;
    return /*#__PURE__*/_react.default.createElement("div", {
      dir: theme.direction
    }, !simAdmin && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tabsDiv
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx7.default)(classes.tabDiv, _defineProperty({}, classes.tabActive, selectedMode === "day")),
      onClick: function onClick() {
        setSelectedMode("day");
        onChangeMode === null || onChangeMode === void 0 ? void 0 : onChangeMode("day");
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      category: "Default",
      variant: "BodyBold"
    }, (_t = t === null || t === void 0 ? void 0 : t("Day")) !== null && _t !== void 0 ? _t : "Day")), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx7.default)(classes.tabDiv, _defineProperty({}, classes.tabActive, selectedMode === "month")),
      onClick: function onClick() {
        setSelectedMode("month");
        onChangeMode === null || onChangeMode === void 0 ? void 0 : onChangeMode("month");
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      category: "Default",
      variant: "BodyBold"
    }, (_t2 = t === null || t === void 0 ? void 0 : t("Month")) !== null && _t2 !== void 0 ? _t2 : "Month")), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.activeDiv,
      style: theme.direction === "rtl" ? {
        right: selectedMode === "month" ? "50%" : 0
      } : {
        left: selectedMode === "month" ? "50%" : 0
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx7.default)(_defineProperty({}, classes.hide, selectedMode !== "month"))
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.yearSelector
    }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
      color: "secondary",
      onClick: function onClick() {
        return setSelectedDay((0, _moment.default)(selectedDay).subtract(1, "y"));
      }
    }, theme.direction === "rtl" ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null) : /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      category: "Default",
      variant: "Body"
    }, selectedDay.get("year")), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
      color: "secondary",
      disabled: selectedDay.get("year") >= now.get("year"),
      onClick: function onClick() {
        return setSelectedDay((0, _moment.default)(selectedDay).add(1, "y"));
      }
    }, theme.direction === "rtl" ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null) : /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null))), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.monthDiv
    }, _lodash.default.range(1, 13).map(function (month) {
      var _clsx4, _t3;
      var pmonth = (0, _moment.default)("".concat(selectedDay.get("year"), "-").concat(month), "YYYY-M");
      var enabledMonth = _lodash.default.chain(enabledDays).groupBy(function (day) {
        return (0, _moment.default)(day, "YYYYMMDD").format("YYYYMM");
      }).keys().value();

      // console.log(pmonth, now, disableAfterToday, now.isBefore(pmonth));

      var disabled = disableAfterToday && now.isBefore(pmonth) || (disableDayBefore === null || disableDayBefore === void 0 ? void 0 : disableDayBefore.isAfter(pmonth)) || !_lodash.default.includes(enabledMonth, pmonth.format("YYYYMM"));
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "month-".concat(month),
        className: classes.monthSelectorDiv
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _clsx7.default)(classes.monthSelector, (_clsx4 = {}, _defineProperty(_clsx4, classes.monthSelectorActive, selectedMonth.get("year") === selectedDay.get("year") && selectedMonth.get("month") + 1 === month), _defineProperty(_clsx4, classes.monthSelectorDisabled, disabled), _clsx4)),
        onClick: !disabled ? function () {
          // mantis - 8604, 해당 월 1일로 setSelectedMonth.
          setSelectedMonth((0, _moment.default)("".concat(selectedDay.get("year"), "-").concat(month), "YYYY-M").startOf("month"));
        } : undefined
      }, (_t3 = t === null || t === void 0 ? void 0 : t(MONTH_ABBR[month])) !== null && _t3 !== void 0 ? _t3 : MONTH_ABBR[month]));
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx7.default)(_defineProperty({}, classes.hide, selectedMode !== "day"))
    }, /*#__PURE__*/_react.default.createElement(_DateSinglePicker.DateSinglePicker, {
      day: selectedDay
      // mobile={mobile}
      ,
      enabledDays: enabledDays,
      onChangeDay: function onChangeDay(day) {
        // mantis - 8604, mode가 day일 때만 setSelectedDay(day)하도록 수정.
        if (selectedMode === "day") {
          // mantis - 9129, 데이터가 존재하는 일자만 선택가능하도록 수정(LeeHJ).
          if (_lodash.default.includes(enabledDays, (0, _moment.default)(day).format("YYYYMMDD"))) {
            setSelectedDay(day);
          }
        }
        setSelectedMonth(day);
      },
      disableAfterToday: disableAfterToday,
      disableDayBefore: disableDayBefore,
      t: t
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.btnDiv
    }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
      variant: "outlined",
      color: "primary",
      className: classes.btn,
      disabled: disableClear,
      onClick: function onClick() {
        var now = (0, _moment.default)();
        if (simAdmin && clearDay) {
          setSelectedMonth(clearDay);
          setSelectedDay(clearDay);
        } else {
          setSelectedMonth(now);
          setSelectedDay(now);
        }
      }
    }, (_t4 = t === null || t === void 0 ? void 0 : t("Clear")) !== null && _t4 !== void 0 ? _t4 : "Clear"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      color: "primary",
      variant: "contained",
      className: classes.btn,
      onClick: function onClick() {
        if (selectedMode === "month") {
          _onClick === null || _onClick === void 0 ? void 0 : _onClick(selectedMonth, selectedMode);
        } else {
          _onClick === null || _onClick === void 0 ? void 0 : _onClick(selectedDay, selectedMode);
        }
        setOpenMenu(false);
      }
    }, (_t5 = t === null || t === void 0 ? void 0 : t("OK")) !== null && _t5 !== void 0 ? _t5 : "OK")));
  }, [classes.activeDiv, classes.btn, classes.btnDiv, classes.hide, classes.monthDiv, classes.monthSelector, classes.monthSelectorActive, classes.monthSelectorDisabled, classes.monthSelectorDiv, classes.tabActive, classes.tabDiv, classes.tabsDiv, classes.yearSelector, clearDay, disableAfterToday, disableClear, disableDayBefore, enabledDays, now, onChangeMode, _onClick, selectedDay, selectedMode, selectedMonth, simAdmin, t, theme.direction]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    rootRef: anchorRef,
    readOnly: true,
    select: true,
    dense: dense,
    value: getValue
    // value={
    //      mode === "month" ? day?.format("MMM, YYYY")
    //     : day?.format("MMM D, YYYY")
    // }
    ,
    disabled: disabled,
    endIcon: simAdmin ? /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null) : /*#__PURE__*/_react.default.createElement(_DateRange.default, null),
    onClick: disabled ? undefined : function () {
      setOpenMenu(function (o) {
        return !o;
      });
    },
    outlinedInputClassName: (0, _clsx7.default)(_defineProperty({}, classes.adminInputBackStyle, simAdmin))
  }), !mobile && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    open: openMenu,
    classes: {
      root: classes.modalNoPadding
    },
    onClickAway: function onClickAway() {
      return setOpenMenu(false);
    },
    anchorEl: anchorRef.current,
    placement: placement !== null && placement !== void 0 ? placement : "bottom-start",
    modifiers: {
      offset: {
        enabled: true,
        offset: "0, 4px"
      }
    }
  }, calendarMarkup), mobile && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    open: openMenu,
    className: classes.modalDiv,
    noPadding: true,
    onClickAway: function onClickAway() {
      return setOpenMenu(false);
    },
    onClose: function onClose() {
      return setOpenMenu(false);
    },
    mobile: mobile,
    content: calendarMarkup
  }));
};
exports.DateSelector = DateSelector;